import { db, FieldValue } from 'helpers/firebase';
import { COUPON_STATUS } from 'constants/coupon';
const serverTimestamp = FieldValue.serverTimestamp;


//CRUD

export const getCouponsRef = () => {
  const ref = db.collection('/coupons').orderBy('created_at', 'desc');
  return ref;
}

export const createCoupon = (data) => {
  const { code } = data;
  if (!code) {
    return Promise.reject(Error('code is required!'));
  }
  const ref = db.doc(`/coupons/${code}`);
  return ref.get()
    .then(docSnap => {
      if (docSnap.exists === false) {
        return ref.set({ ...data, created_at: serverTimestamp(), cur_count: 0 });
      } else {
        return Promise.reject(Error(`${code} is already exist.`));
      }
    })
    .catch(e => console.error('Failed to createCoupon'));
}

export const updateCoupon = (coupon_id, dataToUpdate) => {
  const ref = db.doc(`/coupons/${coupon_id}`);
  return ref.update(dataToUpdate);
}

export const removeCoupon = (coupon_id) => {
  const ref = db.doc(`/coupons/${coupon_id}`);
  return ref.delete();
}